export default {
    required: 'Field required',
    minRequired: 'Field required, minimum length %{min}',
    maxRequired: 'Field required, maximum length %{max}',
    email: 'Invalid email',
    passwordMatch: 'You passwords must match',
    invalidLoginDetails: 'Invalid login details',
    thisAccountIsBanned: 'This account is banned'
}
